export function isDomFeatureApp(featureApp) {
    return typeof featureApp.attachTo === 'function';
}
export function isReactFeatureApp(featureApp) {
    return typeof featureApp.render === 'function';
}
export function isFeatureApp(featureApp) {
    if (typeof featureApp !== 'object' || !featureApp) {
        return false;
    }
    return isDomFeatureApp(featureApp) || isReactFeatureApp(featureApp);
}
//# sourceMappingURL=type-guards.js.map